import { requestPolicyExchange as urqlRequestPolicyExchange } from '@urql/exchange-request-policy';

import { getOperationName } from '@/utils/urql';

const CACHE_ONLY_PRODUCTIVITY_OPERATION_NAMES = [
  'p_UserRole',
  'p_UserInsights',
  'p_UserSkillScores',
  'p_UserMetricScores',
] as const;

export const CACHE_ONLY_OPERATION_NAMES_SET = new Set<string>([
  'okrDetailsFromCache',
  'taskDetailsFromCache',
  'userTooltipFromCache',
  'skillFromCache',
  'orgRoleFromCache',
  'metricDetailsFromCache',
  ...CACHE_ONLY_PRODUCTIVITY_OPERATION_NAMES,
]);

export const requestPolicyExchange = () =>
  urqlRequestPolicyExchange({
    shouldUpgrade: (operation) =>
      !CACHE_ONLY_OPERATION_NAMES_SET.has(getOperationName(operation.query) ?? ''),
  });
